export type DescriptionSubItem = { title: string; description: string };
export type DescriptionItem = string | { text: string; subItems: DescriptionSubItem[] };

export const CreateCampaignType = {
  priceDiscountInBasket: {
    value: 'price_discount',
    i18nKeySuffix: 'priceDiscountInBasket',
    descriptions: [
      'X TL ve \u00FCzeri Y TL indirim uygulan\u0131r. \u00D6rne\u011Fin; 1.000 TL ve \u00FCzeri al\u0131\u015Fveri\u015Flerde 100 TL indirim olu\u015Fturabilirsiniz.',
    ] as DescriptionItem[],
  },
  percentDiscountInBasket: {
    value: 'percentage_discount',
    i18nKeySuffix: 'percentDiscountInBasket',
    descriptions: [
      'X TL ve \u00FCzeri %Y indirim uygulan\u0131r. \u00D6rne\u011Fin; 1.000 TL ve \u00FCzeri al\u0131\u015Fveri\u015Flerde %10 indirim olu\u015Fturabilirsiniz.',
    ] as DescriptionItem[],
  },
  getXPayY: {
    value: 'buy_x_pay_y',
    i18nKeySuffix: 'getXPayY',
    descriptions: [
      'Bir \u00FCr\u00FCnden X adet al\u0131nmas\u0131 durumunda sadece Y adet \u00FCr\u00FCn i\u00E7in \u00F6demenin al\u0131nmas\u0131n\u0131 sa\u011Flar. \u00D6rne\u011Fin; 3 al 2 \u00F6de indirimi olu\u015Fturabilirsiniz.',
    ] as DescriptionItem[],
  },
  buyALotPayLess: {
    value: 'buy_more_pay_less',
    i18nKeySuffix: 'buyALotPayLess',
    descriptions: [
      '\u00C7oklu \u00FCr\u00FCn al\u0131mlar\u0131na y\u00F6nelik %Y oran\u0131nda indirim yap\u0131lmas\u0131n\u0131 sa\u011Flar. \u00D6rne\u011Fin;"2 \u00FCr\u00FCn alana %10, 3 \u00FCr\u00FCn alana %20 indirim" indirimi olu\u015Fturabilirsiniz m\u00FC\u015Fteri \u00FCr\u00FCn say\u0131s\u0131n\u0131 art\u0131rd\u0131k\u00E7a daha y\u00FCksek indirimden yararlan\u0131r.',
    ] as DescriptionItem[],
  },
  takeItTogether: {
    value: 'bundle',
    i18nKeySuffix: 'takeItTogether',
    descriptions: [
      {
        text: 'Bu indirim ile farkl\u0131 \u00FCr\u00FCnleri paket haline getirip, birlikte sat\u0131n al\u0131nmas\u0131n\u0131 istedi\u011Finiz \u00FCr\u00FCnleri se\u00E7erek \u00FCr\u00FCn detay sayfas\u0131nda ve sepette indirimli olarak m\u00FC\u015Fterilerinize sunabilirsiniz. B\u00F6ylece m\u00FC\u015Fteriler hem daha fazla \u00FCr\u00FCn al\u0131r hem de ayr\u0131 ayr\u0131 almaya g\u00F6re tasarruf eder. \u00D6rne\u011Fin; A \u00FCr\u00FCn\u00FC alana B \u00FCr\u00FCn\u00FC % 10 indirimli, A \u00FCr\u00FCn\u00FC alana B \u00FCr\u00FCn\u00FC 50 TL indirimli veya A \u00FCr\u00FCn\u00FC alana B \u00FCr\u00FCn\u00FC sadece 100 TL.',
        subItems: [
          { title: 'Birlikte sat\u0131n al\u0131nmas\u0131n\u0131 istedi\u011Finiz \u00FCr\u00FCnleri se\u00E7in.', description: '' },
          { title: '\u00D6d\u00FCl \u00FCr\u00FCnlerine uygulanacak indirimi belirleyin.', description: '' },
          { title: 'M\u00FC\u015Fteri sepetini olu\u015Ftururken bu \u00FCr\u00FCnleri indirimli fiyatla g\u00F6recek ve kolayca sepete ekleyebilecektir.', description: '' },
        ],
      },
    ] as DescriptionItem[],
  },
  discountOnTheXthItem: {
    value: 'product_discount',
    i18nKeySuffix: 'discountOnTheXthItem',
    descriptions: [
      {
        text: "Sepete eklenen belirlenen s\u0131radaki \u00FCr\u00FCne indirim uygulan\u0131r. \u00D6rn: \"2'nci \u00FCr\u00FCne %50 indirim, 3'\u00FCnc\u00FC \u00FCr\u00FCne 50 TL indirim ve 2'nci \u00FCr\u00FCn 1 TL\" farkl\u0131 indirimler olu\u015Fturabilirsiniz.",
        subItems: [
          {
            title: "X'inci \u00DCr\u00FCne % \u0130ndirim",
            description:
              'Sepete eklenen belirli s\u0131radaki \u00FCr\u00FCne \u00F6zel % indirim uygulan\u0131r. "2\'nci \u00FCr\u00FCne %50 indirim" kampanyas\u0131nda m\u00FC\u015Fteri 2 \u00FCr\u00FCn ald\u0131\u011F\u0131nda, ikinci \u00FCr\u00FCn %50 indirimli olur. Belirledi\u011Finiz indirim, sepetteki en ucuz \u00FCr\u00FCne uygulan\u0131r.',
          },
          {
            title: "X'inci \u00DCr\u00FCne Y TL \u0130ndirim",
            description:
              "Sepete eklenen belirli s\u0131radaki \u00FCr\u00FCne \u00F6zel sabit tutarda indirim uygulan\u0131r. \u00D6rne\u011Fin; 3'\u00FCnc\u00FC \u00FCr\u00FCne 50 TL indirim kampanyas\u0131nda m\u00FC\u015Fteri 3 \u00FCr\u00FCn ald\u0131\u011F\u0131nda, \u00FC\u00E7\u00FCnc\u00FC \u00FCr\u00FCn\u00FCn fiyat\u0131ndan 50 TL d\u00FC\u015F\u00FCl\u00FCr. Belirledi\u011Finiz indirim, sepetteki en ucuz \u00FCr\u00FCne uygulan\u0131r.",
          },
          {
            title: "X'inci \u00DCr\u00FCn Y TL",
            description:
              'Sepetteki belirli s\u0131radaki \u00FCr\u00FCn\u00FCn fiyat\u0131n\u0131 sabitlemeyi sa\u011Flar. "2\'nci \u00FCr\u00FCn 1 TL" kampanyas\u0131nda m\u00FC\u015Fteri 2 \u00FCr\u00FCn ald\u0131\u011F\u0131nda, ikinci \u00FCr\u00FCn\u00FCn fiyat\u0131 yaln\u0131zca 1 TL olur. Belirledi\u011Finiz sabit fiyat, sepetteki en ucuz \u00FCr\u00FCne uygulan\u0131r.',
          },
        ],
      },
    ] as DescriptionItem[],
  },
  fixedPriceInBasket: {
    value: 'fixed_price',
    i18nKeySuffix: 'fixedPriceInBasket',
    descriptions: [
      'Se\u00E7ti\u011Finiz \u00FCr\u00FCnlerin sepette uygulanacak sabit sat\u0131\u015F fiyat\u0131n\u0131 belirleyebilirsiniz. \u00D6rne\u011Fin, fiyat\u0131 1.000 TL olan bir \u00FCr\u00FCn\u00FC indirim s\u00FCresince sepette 900 TL olarak sabitleyebilirsiniz. \u0130ndirim aktifken \u00FCr\u00FCnlerin fiyat\u0131 de\u011Fi\u015Ftirilemez; \u00FCr\u00FCnler indirim s\u00FCresi boyunca sabitlenen fiyattan sat\u0131\u015Fa sunulur.',
    ] as DescriptionItem[],
  },
};

export const CampaignCustomerScope = {
  allCustomers: '1',
  abandonedBasket: '2',
  favoriteProducts: '3',
};

export const campaignCustomerScopeOptions: { value: string; label: string; description: string; tip?: string }[] = [
  {
    value: CampaignCustomerScope.allCustomers,
    label: 'Tüm Müşteriler',
    description: 'İndiriminiz tüm müşterilere açık olacaktır.',
  },
  {
    value: CampaignCustomerScope.abandonedBasket,
    label: 'Sepette Ürün Unutan Müşterilere Özel',
    description: 'Yalnızca müşterinin sepetine eklediği ürünlerinizde geçerli olacaktır.',
    tip: 'Ürünlerinizi sepetine ekleyen müşterilere özel indirim oluşturabilirsiniz. Böylece sepette unutulan ürünlerinizin satışa dönme ihtimali arttırılır.',
  },
  {
    value: CampaignCustomerScope.favoriteProducts,
    label: 'Favoriye Alınan Ürünler',
    description: 'Müşterinin favori ürün listesine eklediği ürünlerde geçerli olacaktır.',
    tip: 'Ürünlerinizi "Beğendiklerim" listesine ekleyen müşterilerinize özel indirimler tanımlayarak, ürünlerinizin sepete eklenme oranını ve satışlarınızı artırabilirsiniz.',
  },
];

export const CART_AGE_MIN_DAYS = 1;
export const CART_AGE_MAX_DAYS = 10;

export const cartAgeDayOptions = Array.from({ length: CART_AGE_MAX_DAYS - CART_AGE_MIN_DAYS + 1 }, (_, index) => CART_AGE_MIN_DAYS + index);
export const getCampaignTypeOptions = (t: (key: string) => string, i18nKeyPrefix: string) =>
  Object.values(CreateCampaignType).map((campaignType) => ({
    value: campaignType.value,
    tip: `A\u00E7\u0131klama: ${t(`${i18nKeyPrefix}.${campaignType.i18nKeySuffix}`)}`,
    label: t(`${i18nKeyPrefix}.${campaignType.i18nKeySuffix}`),
    descriptions: campaignType.descriptions,
  }));
